import React from 'react';
import AccountConfirmationDialog from './AccountConfirmationDialog';

export default function WishlistRemovalDialog({name, ...props}) {
    return <AccountConfirmationDialog {...props}
        title="Remove from wishlist?"
        description={<>Remove <strong>{name}</strong> from your saved favourites? You can save it again later.</>}
        cancelLabel="Keep item" confirmLabel="Remove item" busyLabel="Removing…"
    />;
}
